import React from 'react';
import { FileBarChart } from 'lucide-react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CarDashboardTab from './CarDashboardTab';

/**
 * Componente de visualização modal para o dashboard consolidado do CAR
 * Exibe o CarDashboardTab dentro de uma janela modal
 */
const CarDashboardView = ({ open, onClose, propertyData }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <FileBarChart className="text-green-600 mr-2" size={20} />
            <span>Dashboard Consolidado - CAR</span>
          </div>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <CarDashboardTab propertyData={propertyData} />
      </DialogContent>
    </Dialog>
  );
};

export default CarDashboardView;
